import { Injectable } from '@angular/core';
import { User } from '../../../model/user';
import { Http } from '@angular/http';
import { API_PATH } from '../../../util/constants';
import { Observable } from 'rxjs';

@Injectable()
export class UsuarioService {

  private headers: Headers;
  private opcoes;
  private url;

  constructor(private http: Http) {
    this.headers = new Headers({
      "Allow-Control-Allow-Origin": "*",
      "Allow-Control-Allow-Methods": "GET, POST, PUT, DELETE",
      "Content-Type": "application/json"
    });
    this.opcoes = {headers: this.headers}
  }

  cadastrar(user: User) {
    this.url = `${API_PATH}/usuario`;
    return this.http.post(this.url, user, this.opcoes)
      .map(success => success.status);
  }

  listarUsuarios() {
    this.url = `${API_PATH}/listarUsuarios`;
    return this.http.get(this.url, this.opcoes)
    .map(res => res.json())
     .catch((error: any) => {
      return Observable.throw(error.status);  
    });
  }

  deletar(id) {
    this.url = `${API_PATH}/apagar/${id}`;
    return this.http.delete(this.url, this.opcoes)
      .map(res => res.json())
      .catch((error: any) => {
        return Observable.throw(error.status);
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/gerenciador/dashboard/usuario/usuario.service.ts